// Supported languages
export type Language = 'en' | 'zh';

// Translation strings
interface Translations {
  nav: {
    about: string;
    projects: string;
    contact: string;
  };
  hero: {
    prefix: string;
    roles: string[];
  };
  about: {
    content: string;
  };
  footer: {
    copyright: string;
  };
  aboutMe: {
    title: string;
    bio: string[];
    skills: {
      title: string;
      categories: {
        design: {
          title: string;
          items: string[];
        };
        development: {
          title: string;
          items: string[];
        };
        tools: {
          title: string;
          items: string[];
        };
      };
    };
  };
  projects: {
    title: string;
    items: {
      scrollden: string;
      mysticaReplica: string;
      amir: string;
      casserole: string;
      webDesign: string;
      dream: string;
      designDocs: string;
      camDown: string;
      lamentOfSwan: string;
      others: string;
      gismonda: string;
    };
  };
  amir: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      behindTheScene: string;
      gameplay: string;
      narrative: string;
      challenges: string;
    };
    showcase: {
      title: string;
      items: {
        townScenes: {
          title: string;
          description: string;
        };
        narrativeBox: {
          title: string;
          description: string;
        };
        tradingSystem: {
          title: string;
          description: string;
        };
        combatSystem: {
          title: string;
          description: string;
        };
      };
    };
  };
  scrollden: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      video: string;
      introduction: string;
      gameplay: string;
      upcomingVideo: string;
    };
    showcase: {
      title: string;
      items: {
        world: {
          title: string;
          description: string;
        };
        building: {
          title: string;
          description: string;
        };
        creatures: {
          title: string;
          description: string;
        };
        adventure: {
          title: string;
          description: string;
        };
      };
    };
  };
  mysticaReplica: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      play: string;
      behindTheScene: string;
      gameplay: string;
      narrative: string;
      challenges: string;
    };
    showcase: {
      title: string;
      items: {
        endings: {
          title: string;
          description: string;
        };
        dialogue: {
          title: string;
          description: string;
        };
        investigation: {
          title: string;
          description: string;
        };
        inventory: {
          title: string;
          description: string;
        };
      };
    };
  };
  seemuseums: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      overview: string;
      solution: string;
      features: string;
      market: string;
      platform: string;
    };
  };
  dream: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      about: string;
      job: string;
      reflection: string;
    };
    showcase: {
      title: string;
      items: {
        studies: {
          title: string;
          description: string;
        };
        profile: {
          title: string;
          description: string;
        };
        createStudies: {
          title: string;
          description: string;
        };
        accessCode: {
          title: string;
          description: string;
        };
      };
    };
  };
  casserole: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      behindTheScene: string;
      gameplay: string;
      narrative: string;
      challenges: string;
    };
    showcase: {
      title: string;
      items: {
        branching: {
          title: string;
          description: string;
        };
        miniGames: {
          title: string;
          description: string;
        };
        end: {
          title: string;
          description: string;
        };
        inventoryUI: {
          title: string;
          description: string;
        };
      };
    };
  };
  camDown: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      behindTheScene: string;
      showcase: string;
      gameplay: string;
      playerAttributes: string;
      background: string;
      challenges: string;
      development: string;
    };
    showcase: {
      title: string;
      items: {
        livestream: {
          title: string;
          description: string;
        };
        interactive: {
          title: string;
          description: string;
        };
        gameLoop: {
          title: string;
          description: string;
        };
        strategy: {
          title: string;
          description: string;
        };
      };
    };
  };
  lamentOfSwan: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      behindTheScene: string;
      backgroundStory: string;
      challenges: string;
    };
    showcase: {
      title: string;
      items: {
        puzzles: {
          title: string;
          description: string;
        };
        musicGame: {
          title: string;
          description: string;
        };
        artStyle: {
          title: string;
          description: string;
        };
        storyDriven: {
          title: string;
          description: string;
        };
      };
    };
  };
  designDocs: {
    title: string;
    subtitle: string;
    navItems: string[];
    projectDescriptions: {
      colorChronicles: string;
      desofPan: string;
      witchhunt: string;
      vita: string;
    };
  };
  gismonda: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      gameOverview: string;
      behindTheScene: string;
      backgroundStory: string;
      challenges: string;
    };
    showcase: {
      title: string;
      items: {
        abilitySelection: {
          title: string;
          description: string;
        };
        basicAttack: {
          title: string;
          description: string;
        };
        ring: {
          title: string;
          description: string;
        };
      };
    };
  };
  sage: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      overview: string;
      features: string;
      technology: string;
    };
    features: {
      personalizedLearning: {
        title: string;
        description: string;
      };
      dailyKnowledge: {
        title: string;
        description: string;
      };
      communityContribution: {
        title: string;
        description: string;
      };
      personalArchive: {
        title: string;
        description: string;
      };
    };
  };
  cautions: {
    title: string;
    subtitle: string;
    navItems: string[];
    sections: {
      overview: string;
      features: string;
      architecture: string;
      challenges: string;
    };
    features: {
      cameraDetection: {
        title: string;
        description: string;
      };
      mouseTracking: {
        title: string;
        description: string;
      };
      dataVisualization: {
        title: string;
        description: string;
      };
      containerized: {
        title: string;
        description: string;
      };
    };
  };
}

const translations: Record<Language, Translations> = {
  en: {
    nav: {
      about: "About",
      projects: "Projects",
      contact: "Contact"
    },
    hero: {
      prefix: "I am a",
      roles: ["Programmer", "Game Developer", "Game Designer", "Full-Stack Web Designer", "Senior at NYU"]
    },
    about: {
      content: "I'm passionate about creating innovative digital experiences that merge technology, creativity, and interactive design. With a strong foundation in game design, I approach challenges from multiple angles, balancing storytelling, user engagement, and technical precision. My expertise in both programming and design allows me to bridge the gap between artistic vision and technical requirements, delivering solutions that are both elegant and functional. Whether optimizing code, refining gameplay systems, or designing immersive user experiences, I constantly push the boundaries of what's possible to create meaningful and engaging interactions."
    },
    footer: {
      copyright: "© 2025 Mengxian Gao. All rights reserved."
    },
    aboutMe: {
      title: "About Me",
      bio: [
        "Hi there! I'm Mengxian Gao — a designer and developer passionate about crafting immersive digital experiences that blend form and function. ",
        "Currently a senior at NYU, I'm majoring in Game Design and Computer Science. ",
        "With a background in game development, web technologies, and UI/UX design, I bring a multidisciplinary perspective to every project, connecting creative ideas with technical execution.",
        
      ],
      skills: {
        title: "Skills",
        categories: {
          design: {
            title: "Design",
            items: [
              "UI/UX Design",
              "Interactive Prototyping",
              "Visual Design",
              "3D Modeling"
            ]
          },
          development: {
            title: "Development",
            items: [
              "React",
              "Three.js",
              "TypeScript",
              "WebGL"
            ]
          },
          tools: {
            title: "Tools",
            items: [
              "Figma",
              "Adobe Creative Suite",
              "Blender",
              "Unity"
            ]
          }
        }
      }
    },
    projects: {
      title: "Projects",
      items: {
        scrollden: "SCROLLDEN",
        mysticaReplica: "MYSTICA REPLICA",
        amir: "AMIR",
        casserole: "CASSEROLE",
        webDesign: "WEB DESIGN",
        dream: "DREAM",
        designDocs: "DESIGN DOCS",
        camDown: "CAM DOWN",
        lamentOfSwan: "LAMENT OF SWAN",
        others: "OTHERS",
        gismonda: "GISMONDA"
      }
    },
    amir: {
      title: "AMIR",
      subtitle: "Experience the life of a middle east in the medieval time inspired simulator-like game that features thrilling fighting and strategic trading.",
      navItems: [
        "Behind the scene",
        "Showcase",
        "Game play",
        "Narrative",
        "Challenges"
      ],
      sections: {
        behindTheScene: "I was interested in implementing a dynamic and realistic economic system in the gameplay so that the trading process is more efficient. Our gameplay is thus centered around a trader who travels between towns to trade in and trade out. We attempted to condense on the life of an ordinary trader in the middle ages, and shape the gameplay around that person's experience. This game is essentially a prototype of a game at a much larger scale.",
        gameplay: "The story unfolds with the game tutorial, and thereafter comes with the gameplay (through no block of text). There are seven different endings depending on the objects discovered by the players. The discoverable objects range from wedding photos to newspapers; my intention is to make all the combinations make logical sense.",
        narrative: "Amir does not have any intuitive narrative as it's a prototype of a dynamic trading system.",
        challenges: "We've already had in mind quite a lot of improvements and extra features that could be added to this game. It is a pity for us that we had no time adding NPCs in every town to exchange information on certain commodity prices change— we want them to influence the demand curve in specific ways so that our trading system could be more unpredictable. Our narrative system is implemented but we didn't have the opportunity to add in actual narratives. To present the players an immersive experience of a trader whose life is so different then the ones they are having, we'd love to add in a background story and give the player a purpose in trading. In addition, Along with reducing the health of the player, we believe dropping commodities when defeated by the bandits makes more sense with our level design. We'd love to expand this game in the future."
      },
      showcase: {
        title: "SHOWCASE",
        items: {
          townScenes: {
            title: "Town Scenes",
            description: "The towns are designed to be safe havens where the player is kept away from harm and can trade and interact with NPCs as they please. The visuals at each town hint at their products -- in fact, their names and locations are all based on historical cities that existed."
          },
          narrativeBox: {
            title: "Narrative Box",
            description: "Although the implementation of narratives is rare in our version, as it only appears briefly before trading takes place, we envisioned a game with many more twists and plots. After all, communication is vital in a merchant's life. We want to show how the merchants are exposed to all sorts of information and different choices."
          },
          tradingSystem: {
            title: "Trading System",
            description: "The price generally follows net diffusion. I assume that each town has its unique produce that increases with time, but the overall quantity remains constant. The commodities exchange is behind the scenes and follows a realistic trend. The prices are calculated based on the supply/demand model. We hope the methods we employed for the economic system could give the game a creative touch and prevent the game from generating unrealistic numbers."
          },
          combatSystem: {
            title: "Combat System",
            description: "Trading is a risky adventure. This point was emphasized to us a lot during research. Merchants, before the age of the Industrial Revolution, had to travel long distances, which was a challenging task: they were threatened by bandits and might suffer huge losses. We incorporated this idea into the game and accordingly created the combat system that offers additional gameplay between trading posts."
          }
        }
      }
    },
    scrollden: {
      title: "SCROLLDEN",
      subtitle: "Unveil the secret behind an ancient scroll before time brings all the changes to this world...",
      navItems: [
        "Game play Video",
        "Introduction",
        "Game play",
        "Showcase"
      ],
      sections: {
        video: "Game play Video",
        introduction: "Stumbling upon a dusty relic, the player discovers an ancient scroll sealed inside, containing a world of landscapes, creatures, and myths. The player revives these mystic creatures and builds them a home. In return, they travel between the outside world and the scrolls, obliging the players with resources, revealing hidden secrets, and ranging on adventures.",
        gameplay: "Scrollden is a casual homebuilding and management sim inspired by fantastic creatures in Chinese mythologies. It's a 2D game built in a 3D world. Realizing the significant part our background story plays in distinguishing our games, we incorporated the gameplay into the narratives so that the player could feel the meaning of their actions. Although we're limiting the information offered in the game(few people have the patience to read the novella in a base-building game), we've carefully knitted the plots into the game world and crafted each character as introductions to a new chapter to allow the players to form an intimate relationship with the mystic creatures. Our game offers all the critical aspects of a building game, with enhanced features and a unique building mechanism. The players need to combine puzzle pieces of different materials according to a vague silhouette to build new furniture that makes logical sense. For example, an axe is constructed with stone and a wooden stick tied up by strings. We use a map with locked areas to help the players keep track of the plots and the players' progress. We have showcased earlier versions and prototypes at the Game Developers Conference, EGD Waffle Games, Gamera Games, Playtest Thursdays, and Gumbo Games. We are aiming for a full release in early 2025!",
        upcomingVideo: "A new playtest video is coming soon!",
      },
      showcase: {
        title: "SHOWCASE",
        items: {
          world: {
            title: "Scrollden World",
            description: "Fantastical landscapes filled with mythological elements."
          },
          building: {
            title: "Building Mechanics",
            description: "Puzzle-based furniture creation to deepen player engagement."
          },
          creatures: {
            title: "Mythical Creatures",
            description: "Interactions with legendary beings, each having unique backgrounds and abilities."
          },
          adventure: {
            title: "Scroll Map",
            description: "Resource gathering and exploration connecting the real world to the scroll map world."
          }
        }
      }
    },
    mysticaReplica: {
      title: "MYSTICA REPLICA",
      subtitle: "Discover hidden family secrets through this mini strategy and mystery solving game.",
      navItems: [
        "Play the Game",
        "Behind the scene",
        "Showcase",
        "Game play",
        "Narrative",
        "Challenges"
      ],
      sections: {
        play: "Play the Game",
        behindTheScene: "I received the inspiration for this game from a newspaper article and I thought the story of the mismatched twins could be an interesting topic to expand and explore. The single player mode in overcooked inspired me to do a shift-between-twin-characters mechanism, and the rest of the gameplay, search and find in a time range, is majorly based on the storyline.",
        gameplay: "The game mechanisms are fairly straightforward: the player needs to control two individual characters to secretly search the house for clues. They have to complete their investigation within a time limit while keeping away from their parents' eyes. Although there are two characters involved in the game play, the player has only one set of keys as controllers, which means they can't control both characters simultaneously, and need to constantly shift between the characters. The AI parents who act like enemies in the game are designed to switch between rooms randomly; the players have to be cautious and use both characters to attract them to designated rooms to avoid being caught. To add in some difficulty to the game, I added a timer so that the players could plan their adventures accordingly. The searchable objects are predetermined and are in place to support the narratives.",
        narrative: "The story unfolds with the game tutorial, and thereafter comes with the gameplay (through no block of text). There are seven different endings depending on the objects discovered by the players. The discoverable objects range from wedding photos to newspapers; my intention is to make all the combinations make logical sense.",
        challenges: "Although I achieved my primary goal in this game, the scope is smaller than I had intended as it only lasts for 5 minutes and the replayability is low. There's not much to the gameplay except from luring the parents into adequate rooms, I would love to implement mini puzzle games into the search process. In addition, I'd like to use a better AI for the parents as they now only move along a certain path instead of selecting the quickest path available."
      },
      showcase: {
        title: "SHOWCASE",
        items: {
          endings: {
            title: "Endings",
            description: "The game has seven endings, depending on the items collected by the players within the time limit. Most of them are intended to make logical sense and are hilarious in essence. For example, I have the Addams ending if the player is caught—the family secret is never discovered!"
          },
          dialogue: {
            title: "Dialogue",
            description: "I used Fungus for the narrative panels. There are only brief dialogues at the start of the game to introduce the players to the background story and act as a tutorial. I focused on how I wanted my narrative to promote the witty feel of the game."
          },
          investigation: {
            title: "Investigation System",
            description: "Searching is one of the most predominant features in this game, and I attempt to make it as juicy as possible. The players are not given many hints during the game, and they have to be extra careful with the positions of the parents as enemies. In order to achieve the best ending, the player has to literally look everywhere."
          },
          inventory: {
            title: "Inventory",
            description: "The inventory design was fun to create. I wanted it to somehow resemble a clue board where the items being collected aren't merely names. The players could identify each item and examine the details. In other words, my inventory interface leads the players to discover the truth even without confirming it with the endings."
          }
        }
      }
    },
    seemuseums: {
      title: "SEEMUSEUMS",
      subtitle: "Pioneering the transformation of art education by creating the 'Duolingo for playful art learning'",
      navItems: [
        "Overview",
        "Demo Video",
        "Solution",
        "Features",
        "Market",
        "Platform"
      ],
      sections: {
        overview: "SeeM is pioneering the transformation of art education by creating the 'Duolingo for playful art learning.' Through the digitization of museum collections and AI, we turn artwork into interactive exhibitions with storytelling, gamified features, and personalized learning paths.",
        solution: "SeeMuseums bridges the gap between art lovers and museums by offering an innovative learning platform. Using AI and a collection of 1.1 million public domain artworks, we create interactive, personalized journeys that make art accessible to everyone regardless of background.",
        features: "Our AI Curation recommends exhibitions tailored to users' goals and preferences, while our AI Tour Guide reveals the stories behind each artwork through immersive storytelling. We incorporate gamified features like achievement-based rewards and challenges, transforming passive viewing into active learning.",
        market: "Our platform uses a freemium model at $5/month for premium features. We began by targeting art students from top universities and art schools, with a serviceable obtainable market representing $447 million in monthly revenue. For museums, we offer cost-effective artifact reconstruction with a 50% profit margin.",
        platform: "SeeMuseums provides an end-to-end digitalization solution for museums. Using just a standard 1080p camera to record 360-degree video, we handle the conversion into realistic 3D models for virtual tours. Our platform serves as both a promotional tool and a digital preservation solution, extending the reach and life of museum collections."
      }
    },
    dream: {
      title: "DREAM",
      subtitle: "NYU Create Lab",
      navItems: [
        "About",
        "Showcase",
        "My Job",
        "Reflection"
      ],
      sections: {
        about: "Dream stands for Digital Reference of Experiments and Assessments Manager. It is a Web-based research platform application used for development, cognitive, and educational psychology research experiments. Dream features a collection of cognitive assessments, video games, simulations, and surveys that help researchers collect data.",
        job: "I'm involved in the initial stage of building the platform, employing React along with Sass to construct the platform structures based on the design of one of the lab members. Then, we moved to complete the interactions using Javascript and other essential tools to achieve the platform's functionalities, like collecting data and inputs.",
        reflection: "Through this, I gained a lot of experience working on a functional web platform suitable for providing interactions for a group of different users; I also grew to understand UI/UX better as we need to take into consideration the feedback from our users: the website has to be thorough as well as easy to use. Moreover, working in a group setting, I got the opportunity to cooperate with other lab members, discussing our ideas, helping one another, and finally solving problems."
      },
      showcase: {
        title: "Showcase",
        items: {
          studies: {
            title: "View Studies Page",
            description: "This Page displayed the list of studies under the experience center section. Users could interact to create and delete studies, also search for and modify the existing ones."
          },
          profile: {
            title: "Profile Page",
            description: "This Page displayed the user information. Users could change their profile information, change their user avatar, and reset their password. This page is accessible through all web pages."
          },
          createStudies: {
            title: "Create Studies Page",
            description: "This Page is used to create a new study. After all the information is entered by the user, the button at the bottom right will lead the user to a page displaying all the collected data for final review."
          },
          accessCode: {
            title: "Create Access Code",
            description: "This Page is used to create access code for the studies created. The user needs to enter information to ensure the study is evident to its audience. The picture displays a transition process in step two."
          }
        }
      }
    },
    casserole: {
      title: "CASSEROLE",
      subtitle: "Cook the WORLD'S BEST casserole to win the competition and adopt the comic books you ever wanted. A fun puzzle solving game that pieces together the best recipe.",
      navItems: [
        "Behind the scene",
        "Showcase",
        "Game play",
        "Narrative",
        "Challenges"
      ],
      sections: {
        behindTheScene: "A game maker game that combines narratives with a fun collect/craft-recipes mechanism. Our idea comes from a cooking game that requires the correct combination of ingredients. Instead of having a failure message being displayed for distinctive combinations, I wanted to explore the chances of designing unique recipes. The clues provided in the game hinted at the perfect recipe, but the players are allowed to create their own — received with mixed results.",
        gameplay: "The game play is essentially a puzzle solving game, but a combination of small games as well, for example, the player has to complete certain tasks to retrieve their desired ingredients. The players are directed to follow the instructions at the start of the game so then they can learn the mechanism of the game through the conversation. If they choose to diverge and do something else, they are eventually led back to the designed path as the game could not proceed with proper instructions. The next step is to collect as many ingredients as possible: there's no time limit set to it so that the player is allowed to explore the map freely before they decide to make a go at making the casserole. The final scene is triggered as soon as the player decides the ingredients to use.",
        narrative: "I use humorous language in the game to create a casual and hilarious narrative style. The whole idea of creating the best casserole for comic books is absurd to begin with, therefore the narratives, along with different choices provided to the player are witty and funny. I also aim to provide hidden clues throughout the conversations between the players and the NPCs so that those who wish to pursue the perfect recipe could get a satisfactory result. Our gameplay could not stand on its own without proper background knowledge, we built the narrative to combine different sections of the games together.",
        challenges: "I enjoyed making this game as I embedded interesting twists and turns into the narrative and gameplay. However, the game itself is not as challenging as I see fit as the mini games incorporated are straightforward and easy to follow. Again, the replayability is low as the players could easily get tired after a few rounds. This game is transformable in the sense that the player could be cooking different dishes to serve various purposes: and the landscope/map could be procedurally generated so that the players wouldn't get bored with repetitive processes like picking apples."
      },
      showcase: {
        title: "SHOWCASE",
        items: {
          branching: {
            title: "Branching",
            description: "The narrative system offers many unanticipated twists in a tone of black humor to comply with the game's overall aesthetics. You might end up annoyed by a weird ending that only far-fetchedly makes sense—like the first choice, which leads directly to the end. We made our narrative boxes from Sketch to blend them well with other system UIs."
          },
          miniGames: {
            title: "Mini Games",
            description: "We include many mini-games for players to collect corresponding ingredients. Although they are easy and often self-explanatory, we hope to add some additional gameplay to the game's progression and prevent the players from quickly listing ingredients for cooking, which is not encouraged because they won't reach the perfect ending(by which i mean winning the favor from the NPCs), ignoring the clues."
          },
          end: {
            title: "End",
            description: "There are seven endings based on the player's final selection of ingredients; they'll need to report back to the NPCs and face their judgment from there. As we include many unconventional casserole ingredient choices, such as cookies and apples, many endings are written so that they correspond to the strange ingredients being ended. The players could have fun creating whatever casseroles they prefer and explore the endings freely."
          },
          inventoryUI: {
            title: "Inventory UI",
            description: "The inventory UI is a vital part of the game as it guides the player and decides the game's ending. Ingredients automatically show up once the players collect them in the game, but the player could reconsider their selection and decide on the ingredients before they move on to cooking. The inventory allows the players to keep track of their progress on collecting, but it doesn't hint at what needs to be added, which creates some challenges."
          }
        }
      }
    },
    camDown: {
      title: "CAM DOWN",
      subtitle: "A multiplayer horror game inspired by Content Warning and Lethal Company, where interstellar explorers livestream their journeys to earn revenue.",
      navItems: [
        "Behind the Scenes",
        "Showcase",
        "Game Loop",
        "Player Attributes",
        "Background Story",
        "Challenges",
        "Development Status"
      ],
      sections: {
        behindTheScene: "We loved the game Content Warning and decided to create our own unique twist on it. We aimed to incorporate classic elements of horror games, such as looping rooms, to deepen the eerie atmosphere. Additionally, we expanded on the filming mechanics. Players receive livestream data powered by AI, allowing them to adjust strategies on the fly and complete special in-game tasks assigned by their top supporters. We also recognized the importance of the cooperation feature, which has contributed to the popularity of games in this genre, and made it a key part of our design.",
        showcase: "Game Showcase",
        gameplay: "The core game loop involves signing a contract to become a \"STELLARCAST\" streamer, renting equipment and forming a team, choosing destinations, encountering alien creatures and paranormal phenomena, creating engaging content, returning to base to earn revenue and repay debts, and finally upgrading equipment for the next mission.",
        playerAttributes: "Strategic depth is provided through player attribute dynamics including Vitality (critical for survival), Oxygen Levels (governing exploration duration), Endurance (regulating player exertion), and SAN Integrity (diminishing with monster encounters, triggering debuffs at low levels).",
        background: "In the 22nd century, StellarCast monopolized interstellar media. As a contracted streamer, players hunt for extraterrestrial paranormal events to earn \"StarEye\" currency. The platform's algorithm scores content on horror, absurdity, and mystery, determining access to better gear. To venture into more perilous star systems, players must push the limits of their audience's appetite for the bizarre.",
        challenges: "Steep learning curve, balancing horror difficulty with entertainment, frequent updates required.",
        development: "In Development. A playable prototype is available. We are currently focusing on developing procedural content and implementing the looping room system. In the next stage, we plan to improve overall performance and integrate external systems such as voice chat and an achievement system."
      },
      showcase: {
        title: "SHOWCASE",
        items: {
          livestream: {
            title: "Secrets of the Livestream",
            description: "Simply filming monsters won't cut it—players must stage thrilling moments to boost audience engagement. Close calls capture near-miss attacks for maximum suspense. Creative chaos encourages dodging strikes, taunting creatures, or dancing for extra views. Team stunts involve filming teammates in daring encounters."
          },
          interactive: {
            title: "Elevating Interactive Player Feedback",
            description: "Real-Time Feedback: Players receive live stream data to adjust strategies and complete in-game tasks from top supporters. Player Engagement: Deceased players join as ghostly viewers, interacting via messages and tips, maintaining engagement with the team."
          },
          gameLoop: {
            title: "Game Loop",
            description: "1. Sign Contract: Become a \"STELLARCAST\" streamer. 2. Gear Up: Rent a spaceship and streaming equipment, form a team. 3. Choose Destination: Select a location and embark. 4. Encounter Challenges: Face alien creatures and paranormal phenomena. 5. Create Content: Strive to produce engaging live streams to gain popularity. 6. Return & Profit: Head back, earn revenue, and repay debts. 7. Upgrade: Purchase advanced equipment and prepare for the next mission."
          },
          strategy: {
            title: "Strategic Depth - Player Attribute Dynamics",
            description: "Vitality: The critical measure ensures player survival. Oxygen Levels: Governs exploration duration, depleting over time and accelerating during recovery phases. Endurance: Regulates player exertion; slow regeneration necessitates strategic planning. SAN Integrity: Central to interactions, diminishes with monster encounters; low levels trigger debuffs such as restricted movement and impaired functionality, compelling players to tactically employ \"CAM DOWN\"."
          }
        }
      }
    },
    lamentOfSwan: {
      title: "LAMENT OF SWAN",
      subtitle: "A story-driven 2D side-scrolling narrative horror game that blends psychological horror elements with intense dramatic tension. You are not dancing on a stage—you are struggling in the depths of despair.",
      navItems: [
        "Behind the Scenes",
        "Showcase",
        "Background Story",
        "Challenges and Improvements"
      ],
      sections: {
        behindTheScene: "We based this project on our previous game jam entry. Players take on the role of a ballerina obsessed with ballet and driven by an intense desire for greatness, even as her mental state gradually deteriorates. We carefully designed the puzzles to align with the narrative, using environmental storytelling to highlight the protagonist's growing horror and depression. I was responsible for developing the music gameplay system — a core mechanic that appears in every chapter, serving as a reflection of the protagonist's dancing. Additionally, I worked on many of the sub-puzzles and supporting systems, including the user interface.",
        backgroundStory: "The protagonist has loved dancing since childhood and eventually fulfills her dream of joining a prestigious ballet troupe. However, the company director subjects her to relentless mistreatment, and her struggles go unnoticed and misunderstood by the other dancers. Her obsessive pursuit of perfection and her growing arrogance gradually isolate her from her peers. Amid her loneliness, she meets a kind-hearted male dancer whose warmth rekindles her fading hopes. Yet, the trust she places in him ultimately leads to betrayal. Devastated, the protagonist's mind descends into darkness and paranoia. In the depths of despair and rage, she sets the theater ablaze, reducing it to ashes—and with it, everyone inside.",
        challenges: "Implemented the narrative using Fungus, but encountered several tool limitations during development. Faced challenges in balancing puzzle difficulty — aimed to avoid making puzzles overly intense while keeping them engaging and meaningful. Focused on improving environmental storytelling, striving to create a seamless experience where narrative and gameplay are naturally intertwined."
      },
      showcase: {
        title: "SHOWCASE",
        items: {
          puzzles: {
            title: "Complementary side puzzles",
            description: "Numerous small puzzles form the foundation of our game. Players must solve each puzzle to gradually uncover the inner world of the protagonist and progress through the storyline."
          },
          musicGame: {
            title: "Music Game",
            description: "The music game represents the segments where the protagonist is dancing. Each song was carefully crafted to be distinct, reflecting different emotional stages of the character. The key patterns are generated automatically based on audio cues, using Wwise to create a dynamic and synchronized gameplay experience."
          },
          artStyle: {
            title: "Game Art Style",
            description: "The visual style draws inspiration from the theatrical lighting and dramatic stage aesthetics of the 1980s, presenting an extreme contrast between the lavish beauty of the ballet stage and the grotesque distortions of her psychological breakdown."
          },
          storyDriven: {
            title: "Story-Driven Experience",
            description: "The game places a strong emphasis on narrative, with multiple storylines that are shaped by the player's choices. Players must pay close attention to the narrative panels, as they provide vital information needed to progress. Our goal is to tell the story through gameplay itself, creating an experience where mechanics and narrative are deeply intertwined."
          }
        }
      }
    },
    designDocs: {
      title: "DESIGN DOCS",
      subtitle: "Game Design Documentation",
      navItems: [
        "Color Chronicles",
        "Descendents of Pan",
        "Witch Hunt",
        "Vita"
      ],
      projectDescriptions: {
        colorChronicles: "Design Doc of a 2D strategy game inspired by Middle Ages craftmanship. The players extract and mix colors from different materials to make/create color pigments.",
        desofPan: "Design Doc of a 2D adventure game inspired by Greek mythology; the player has to restore Pan's flute to save their land. It has a unique art style and a theme of raising environmental awareness.",
        witchhunt: "Design Doc of a tabletop card game inspired by the witch hunt history; the player has to attack each to avoid arbitrarily becoming the victim.",
        vita: "Design Doc for a fitness app targeting young women. It includes many aspects of a health routine from diet to exercise."
      }
    },
    gismonda: {
      title: "GISMONDA",
      subtitle: "A side-scrolling action game inspired by Gismonda (1894), Victorien Sardou's Greek-set melodrama.",
      navItems: [
        "Game Overview",
        "Behind the Scenes",
        "Showcase",
        "Background Story",
        "Challenges and Improvements"
      ],
      sections: {
        gameOverview: "\"Noble Eos, or whichever name you prefer, Goddess of the holy light...\nI pray to you in reverence.\"\n\nGismonda is a side-scrolling action game inspired by Gismonda (1894), Victorien Sardou's Greek-set melodrama.\nThe story follows the journey of a warrior queen seeking revenge and personal growth. Her character defines our combat design—elegant, composed, and deliberate in every move.\nDrawing inspiration from Hades, the game allows players to craft their own combat style by combining different skills to build their abilities.\n We've poured our hearts into designing the boss battles. The main boss features two distinct stages, each carefully crafted to offer a unique and challenging experience.",
        behindTheScene: "I crafted the background story and world lore based on the original play, aligning the narrative closely with gameplay by designing player skills that reflect the protagonist's personality, emotional journey, and growth. The player's skill set centers around light. For instance, I designed the Sky Beam, a high-damage ability where a massive beam of sunlight strikes the player's current position after a short delay. To avoid taking damage, players must strategically reposition after summoning it, adding a layer of risk and tactical depth.\nIn addition to world view and narrative design, I contributed to core gameplay programming, including player abilities, game state management, and the 3C system (Character, Controls, Camera), ensuring fluid and responsive moment-to-moment gameplay. I also implemented the UI system using multiple canvases, designing and integrating intuitive, visually cohesive interfaces that supported both usability and the narrative tone.",
        backgroundStory: "Our game presents an alternate version of the events that unfold during the timeline of Gismonda, reimagining the story through a mythic lens.\nIn this adaptation, Gismonda is portrayed as a determined, courageous, and strong-willed warrior queen. At the beginning of the game, she receives the blessing of a goddess who seeks to help her protect her honor and family. The goddess bestows upon her divine combat abilities, including the power to wield rings of light for both offense and defense in battle.",
        challenges: "A number of additional skills and combo systems were conceptualized but not fully implemented in the current version.\nWe plan to expand the game's scope by introducing more bosses, allowing us to fully realize its intended depth and potential.",
      },
      showcase: {
        title: "SHOWCASE",
        items: {
          abilitySelection: {
            title: "Ability Selection",
            description: "Players are granted abilities by the goddess and must choose between different options to shape a skill set that reflects their unique playstyle."
          },
          basicAttack: {
            title: "Basic Attack",
            description: "We didn't implement defense to encourage voluntary action towards the boss. Perform attacks to deal damage. Every attack that hits will charge up the Halo, allowing Gismonda to perform Special attacks and abilities."
          },
          ring: {
            title: "Ring",
            description: "When the halo reaches full charge, Gismonda will passively regenerate health. Using a Special ability consumes 2 rings, while dashing consumes 1 ring."
          }
        }
      }
    },
    sage: {
      title: "SAGE",
      subtitle: "A Daily App to Cultivate Learning Habits",
      navItems: [
        "Project Overview",
        "Key Features",
        "Technology Stack"
      ],
      sections: {
        overview: "Sage is a conceptual learning application designed to promote continuous learning without forced goal-driven pressure. The app provides short knowledge snippets in the background daily, allowing users to learn new facts, words, or skills during fragment time. Users can set learning preferences to receive personalized content while also contributing knowledge through short text to share with the community. There are no professors, homework, grades, or commitments—just learning cultivated as a habit for self-improvement.",
        features: "Key Features",
        technology: "Technology Stack"
      },
      features: {
        personalizedLearning: {
          title: "Personalized Learning Preferences",
          description: "Allows users to define their preferred content types and topics, enabling a tailored and relevant learning experience."
        },
        dailyKnowledge: {
          title: "Daily Knowledge Snippets",
          description: "Delivers curated, bite-sized insights each day to encourage consistent, habit-forming engagement with new information."
        },
        communityContribution: {
          title: "Community Knowledge Contribution",
          description: "Empowers users to contribute short-form knowledge content, fostering a collaborative and diverse knowledge-sharing ecosystem."
        },
        personalArchive: {
          title: "Personal Knowledge Archive",
          description: "Enables users to bookmark and organize interesting facts for easy access and long-term reference."
        }
      }
    },
    cautions: {
      title: "CAUTIONS",
      subtitle: "Online Focus Detection System",
      navItems: [
        "Project Overview",
        "Key Features",
        "Technical Architecture",
        "Technical Challenges & Solutions"
      ],
      sections: {
        overview: "The Online Focus Detection System is a containerized application designed to monitor and analyze user focus during online courses. It consists of three interconnected subsystems: a Machine Learning Client that collects and analyzes data from sensors such as cameras and mouse movements; a Web App that provides an interface to visualize collected data and display analytical results; and a MongoDB database that stores sensor data and analytical metadata for seamless integration.",
        features: "Key Features",
        architecture: "Technical Architecture",
        challenges: "The primary challenges in developing the system were integrating camera access within a containerized environment and implementing real-time data processing with minimal resource consumption. The camera integration issue was resolved through customized Docker configurations and, when necessary, by leveraging browser-based access as an alternative. To address performance constraints, we employed efficient streaming data processing techniques optimized for low-latency and low-overhead operation. Additionally, the system incorporates robust error-handling mechanisms to ensure continued functionality, even when sensor data becomes temporarily unavailable."
      },
      features: {
        cameraDetection: {
          title: "Camera-Based Attention Detection",
          description: "Utilizes facial recognition technology to assess whether the user is actively looking at their screen, enabling accurate focus measurement."
        },
        mouseTracking: {
          title: "Mouse Activity Tracking",
          description: "Continuously monitors mouse movements, clicks, and scroll behavior to evaluate levels of user interaction and engagement."
        },
        dataVisualization: {
          title: "Real-Time Data Visualization",
          description: "Delivers a responsive, web-based interface for presenting focus metrics and analytical insights in real time."
        },
        containerized: {
          title: "Containerized Deployment Architecture",
          description: "Employs a modular, Docker-based architecture to ensure scalability, portability, and ease of deployment across environments."
        }
      }
    }
  },
  zh: {
    nav: {
      about: "关于我",
      projects: "过往项目",
      contact: "联系方式"
    },
    hero: {
      prefix: "我是一名",
      roles: ["程序员", "游戏开发者", "游戏设计师",  "全栈网页设计师", "纽约大学大四学生"]
    },
    about: {
      content: "我热爱用科技与创意打造新颖有趣、富有沉浸感的数字体验。扎实的游戏设计基础让我能够从不同角度理解问题，在叙事结构、玩家体验与技术实现之间找到理想的平衡。结合编程与设计的双重专长，我善于将艺术想象转化为具体可行的作品。无论是打磨游戏机制、优化代码，还是设计引人入胜的交互体验，我都乐于挑战自我，持续探索数字世界中更多的可能性。"
    },
    footer: {
      copyright: "© 2025 高梦娴。保留所有权利。"
    },
    aboutMe: {
      title: "关于我",
      bio: [
        "嗨！我是高梦娴，一名设计师兼开发者，热衷于打造融合形式与功能、富有沉浸感的数字体验。我目前是纽约大学的大四学生，主修游戏设计与计算机科学。扎实的游戏设计背景让我在创作中始终关注叙事性、玩家体验与系统深度的平衡。",
        "结合游戏开发、网页技术和UI/UX设计等多领域经验，我能够以多学科的视角参与项目，推动创意与技术的深度融合，创造出既有趣又富有表现力的互动体验。",
        ],
      skills: {
        title: "技能",
        categories: {
          design: {
            title: "设计",
            items: [
              "UI/UX设计",
              "交互原型制作",
              "视觉设计",
              "3D建模"
            ]
          },
          development: {
            title: "开发",
            items: [
              "React",
              "Three.js",
              "TypeScript",
              "WebGL"
            ]
          },
          tools: {
            title: "工具",
            items: [
              "Figma",
              "Adobe创意套件",
              "Blender",
              "Unity"
            ]
          }
        }
      }
    },
    projects: {
      title: "过往项目",
      items: {
        scrollden: "SCROLLDEN 卷中坞",
        mysticaReplica: "MYSTICA REPLICA 重复之谜",
        amir: "AMIR 阿米尔",
        casserole: "CASSEROLE 梦想炖菜",
        webDesign: "WEB DESIGN 网页设计",
        dream: "DREAM 纽约大学创意实验室",
        designDocs: "DESIGN DOCS 设计文档",
        camDown: "CAM DOWN 禁区实况",
        lamentOfSwan: "LAMENT OF SWAN 天鹅挽歌",
        others: "OTHERS 其他项目",
        gismonda: "GISMONDA 吉斯蒙达"
      }
    },
    amir: {
      title: "AMIR阿米尔",
      subtitle: "体验一款受中世纪中东生活启发的模拟类游戏，融合刺激的战斗和策略性交易。",
      navItems: [
        "背后故事",
        "游戏展示",
        "游戏玩法",
        "背景故事",
        "挑战与改进"
      ],
      sections: {
        behindTheScene: "我加入团队的初衷是希望能为经济和战斗系统的开发贡献力量。我对在游戏中实现一个真实经济模型充满兴趣，希望通过代码自动处理复杂的数学运算，让玩家能够沉浸式地体验交易乐趣。在战斗系统设计上，我们特意避免给玩家施加过大压力，因为我们希望玩家能将注意力集中在交易体验上。因此，我们没有设计任何Boss战，并确保玩家可以选择逃跑以避免战斗。我们的目标是鼓励玩家在做出交易决策时认真考虑潜在的风险和损失。本游戏作为未来大型项目的原型开发版。",
        gameplay: "我们的核心机制旨在真实还原中世纪商人的生活。我们实现了一个动态且真实的经济系统，确保玩家必须通过策略性交易并在旅途中考虑潜在的损失。游戏围绕着一位在中世纪背景下旅行的商人展开，玩家将穿梭于受真实历史城镇启发的城市之间。为了体现长途贸易的危险性，敌人可能会在城镇之间的路线上随机出现。如果玩家未能击败敌人或成功逃脱，便有可能被抢走随身财物。",
        narrative: "《Amir》暂时并未构建详细的叙事内容，主要专注于交易系统的原型开发。",
        challenges: "我们计划但尚未实现的改进包括：在城镇中增加NPC，动态影响商品价格。扩展叙事系统，加入背景故事，为玩家的交易行为赋予动机。优化战斗系统：除了减少玩家生命值外，当玩家被山贼击败时，还会失去一部分携带的商品，以提升游戏体验的合理性。团队对未来进一步扩展和打磨这款游戏充满兴趣。"
      },
      showcase: {
        title: "游戏展示",
        items: {
          townScenes: {
            title: "城镇场景",
            description: "城镇是玩家的安全区，玩家可以在此自由交易并与NPC互动。每个城镇的视觉设计暗示了其特产，并基于真实历史城市构建。"
          },
          narrativeBox: {
            title: "叙事框架",
            description: "虽然目前叙事元素较少，但我们强调了沟通在商人生活中的重要性，帮助玩家了解潜在的危险和影响价格变化的因素。未来计划扩展故事线，增加更多情节转折和玩家选择。"
          },
          tradingSystem: {
            title: "交易系统",
            description: "交易系统基于供需模型，采用了现实的定价机制。每个城镇的产出会随着时间增长，但总体数量保持稳定，从而避免出现不现实的经济数据。"
          },
          combatSystem: {
            title: "战斗系统",
            description: "游戏中将贸易描绘成一次充满风险的冒险。受到历史上商旅遭遇威胁的启发，我们加入了战斗系统，在贸易途中增加了紧张感和挑战性。"
          }
        }
      }
    },
    scrollden: {
      title: "卷中坞",
      subtitle: "揭开远古卷轴的秘密，在时光变迁前探索这个神秘世界...",
      navItems: [
        "游戏试玩视频",
        "背景故事",
        "游戏玩法",
        "展示亮点"
      ],
      sections: {
        video: "游戏试玩视频",
        introduction: "远古之时，不周山天柱断裂，天地陷入水火之灾，女娲娘娘以七彩石补天，拯救了天下苍生。在那之后，生灵万物在她的庇佑下生生不息。岁月如白驹过隙，距今已过去了数千年。有一天，女娲的使者，拥有操控灵魂与自然之力的巫接到了女神的任命。女娲曾游历九州，感于山川灵秀，造物奇妙，以神器：名为镜卷的卷轴映刻山海之景。不周山大劫之时，众多生灵精怪不幸殒命。女娲娘娘心生怜悯，于是将它们的残魂封印于卷轴之中，期盼能助它们修复碎裂的魂魄，得以复生。如今，这些妖怪聚魂渐趋圆满，即将从千年的沉眠中苏醒。在东海深处，有一座远离尘世，灵气充沛的仙岛，女娲希望巫能够前往那里，为这些重生的妖怪引路护航，助它们恢复记忆，建立家园，在沧海桑田的变迁中，寻得一方归宿。",
        gameplay: "《Scrollden》融合了建造、探索、资源管理与叙事驱动的玩法。主要特色包括：生灵复苏：玩家可以与基于中国神话的神秘生物建立深厚的情感纽带。拼图式建造机制：玩家需通过逻辑组合不同的材料（如用石头和木棍绑扎制作斧头）来建造家具和工具。探索与锁定区域：卷轴地图中分布着生物、记忆碎片与资源，玩家必须探索并利用这些元素推动游戏进程，最终揭开隐藏在古老遗物中的秘密。叙事融合：故事线巧妙地穿插在游戏机制中，让玩家的每一个动作都富有意义，同时避免大量文字带来的阅读负担。原型展示：《Scrollden》已在多个展会亮相，包括：Game Developers Conference（GDC）、EGD Waffle Games、Gamera Games、Playtest Thursdays 和 Gumbo Games。正式版预计于2025年底发布。",
        upcomingVideo: "我们即将推出新的游戏测试视频，敬请期待！",
      },
      showcase: {
        title: "展示亮点",
        items: {
          world: {
            title: "卷轴世界",
            description: "充满神话元素的奇幻景观。"
          },
          building: {
            title: "建造机制",
            description: "通过拼图式材料组合，深化玩家的参与感。"
          },
          creatures: {
            title: "神话生物",
            description: "与拥有独特背景故事和能力的传说生物互动。"
          },
          adventure: {
            title: "卷轴地图",
            description: "在现实世界与卷轴世界之间进行资源收集与探索。"
          }
        }
      }
    },
    mysticaReplica: {
      title: "重复之谜",
      subtitle: "在这款小型策略与解谜游戏中揭开隐藏的家族秘密。",
      navItems: [
        "游戏试玩",
        "背后故事",
        "游戏展示",
        "游戏玩法",
        "故事叙述",
        "挑战与改进"
      ],
      sections: {
        play: "游戏试玩",
        behindTheScene: "灵感来源于一篇关于错配双胞胎的新闻报道。角色切换机制受到了游戏《Overcooked》单人模式的启发。\"寻找与发现\"式的探索玩法与剧情紧密结合，强调限时探索与角色切换的重要性。",
        gameplay: "玩家需要通过一套共享的控制键同时操控两名角色，在房屋中秘密地搜索线索。父母作为AI敌人，会在各房间随机巡逻，玩家需要通过策略性地切换角色来吸引父母进入不同的房间，从而为另一角色制造探索机会。游戏设有倒计时，增加挑战性和紧迫感，鼓励玩家合理规划行动路线和时间分配。",
        narrative: "故事线通过游戏过程自然展开，而非通过大量文字叙述。玩家通过发现诸如结婚照、报纸等物品来逐步拼凑家族的秘密。根据所收集物品的不同组合，玩家可以解锁七种不同的结局。",
        challenges: "尽管游戏成功实现了最初目标，但整体规模比预期要小，游戏时长大约只有五分钟左右。由于游戏玩法主要集中在引导父母进入不同房间，导致可重玩性较低。未来的改进方向包括：在搜查过程中增加更多迷你谜题小游戏；升级父母AI，使其能够选择更智能的路径，而非简单的随机移动。"
      },
      showcase: {
        title: "游戏展示",
        items: {
          endings: {
            title: "结局",
            description: "游戏包含七种不同的结局，取决于玩家在时间限制内收集到的物品。这些结局旨在逻辑上合理，且多数带有幽默感。"
          },
          dialogue: {
            title: "对话",
            description: "游戏使用 Fungus 工具在开场阶段提供简短的叙事面板，快速引导玩家了解背景故事并作为教程的一部分。"
          },
          investigation: {
            title: "调查系统",
            description: "玩家需要在提示极少的环境中仔细搜查房屋，这是为了故意提高游戏的紧张感。同时，玩家还需躲避在房子中随机巡逻的父母，父母在游戏中被设定为\"敌人\"角色。"
          },
          inventory: {
            title: "物品栏",
            description: "物品栏设计灵感来源于调查时使用的线索板。玩家收集到的物品可以详细查看，即使未达成所有结局，也可以通过物品推理出故事线索。"
          }
        }
      }
    },
    seemuseums: {
      title: "SeeMuseums",
      subtitle: "开创艺术教育的变革，打造\"艺术学习的多邻国\"",
      navItems: [
        "概述",
        "视频演示",
        "解决方案",
        "功能特色",
        "市场分析",
        "平台技术"
      ],
      sections: {
        overview: "SeeM正在开创艺术教育的变革，打造\"艺术学习的多邻国\"。通过博物馆藏品的数字化和AI技术，我们将艺术品转化为融合互动叙事、游戏化元素和个性化学习路径的动态虚拟展览。",
        solution: "SeeMuseums通过提供创新的学习平台，架起了艺术爱好者与博物馆之间的桥梁。利用AI技术和110万件公共领域艺术品，我们创造互动、个性化的旅程，使艺术变得人人可及，不受背景限制。",
        features: "我们的AI策展功能根据用户的目标和偏好推荐定制展览，AI导游通过沉浸式讲述揭示每件艺术品背后的故事。我们融入基于成就的奖励和互动挑战等游戏化功能，将被动观看转变为主动学习。",
        market: "我们的平台采用免费增值模式，高级功能每月收费5美元。我们最初针对顶尖大学和艺术学院的艺术专业学生，可服务市场每月约4.47亿美元。对博物馆，我们提供成本效益高的文物重建服务，维持约50%的利润率。",
        platform: "SeeMuseums为博物馆提供端到端的数字化解决方案。仅使用标准1080p摄像机录制360度视频，我们负责转换成虚拟导览的高度真实3D模型。我们的平台既是强大的推广工具，又是数字保存方案，扩展了博物馆藏品的覆盖范围和使用寿命。"
      }
    },
    dream: {
      title: "DREAM",
      subtitle: "纽约大学创意实验室",
      navItems: [
        "关于项目",
        "功能展示",
        "我的工作",
        "项目反思"
      ],
      sections: {
        about: "DREAM（全称：Digital Reference of Experiments and Assessments Manager，数字实验与评估管理平台）是一个基于网页的研究平台，专为认知、发展与教育心理学实验而开发。DREAM 为研究人员提供了认知测评、电子游戏、模拟实验和调查问卷的集合，旨在帮助高效地收集数据。",
        job: "我参与了 DREAM 平台新版的建设工作。使用 React 进行平台基础架构设计与实现，确保组件可重用、系统具备可扩展性和响应性。根据UI设计师提供的详细设计原型，开发出符合最佳实践标准的清晰、模块化代码，确保项目整体风格一致。负责使用 JavaScript 和相关支持库开发交互功能，集成了动态行为特性，包括：实时表单校验、用户认证流程和流畅的数据收集过程。通过创建直观、响应迅速的UI组件和处理复杂用户交互，提升了整个平台的可用性与用户体验。",
        reflection: "通过本次项目，我积累了丰富的开发经验，能够构建支持多样化用户交互的功能性网页平台。在此过程中，我加深了对 UI/UX设计 的理解，认识到结合用户反馈在提升平台易用性和完善性方面的重要性。与实验室成员的协作也进一步锻炼了我的团队合作能力，包括：讨论与分享想法、互帮互助、共同解决实际开发中的问题。"
      },
      showcase: {
        title: "功能展示",
        items: {
          studies: {
            title: "查看研究页面",
            description: "展示\"体验中心\"板块下的所有研究列表。用户可以创建、删除、搜索和修改已有研究项目。"
          },
          profile: {
            title: "个人资料页面",
            description: "展示用户的基本信息。用户可以更新个人资料、修改头像以及重置密码。"
          },
          createStudies: {
            title: "创建研究页面",
            description: "允许用户输入信息以创建新的研究项目。在完成数据录入后，系统会引导用户进入一个最终审核页面，集中展示所有已收集的信息。"
          },
          accessCode: {
            title: "创建访问码页面",
            description: "允许用户为已创建的研究项目生成访问码。用户需要填写关键信息，以确保研究对参与者来说清晰可见、便于访问。"
          }
        }
      }
    },
    casserole: {
      title: "梦想炖菜",
      subtitle: "制作世界上最好的炖菜赢得比赛，获得你一直想要的漫画书。一个将最佳配方拼凑在一起的有趣解谜游戏。",
      navItems: [
        "背后故事",
        "游戏展示",
        "游戏玩法",
        "故事叙述",
        "挑战与改进"
      ],
      sections: {
        behindTheScene: "这是一款将叙事与趣味收集/制作食谱机制相结合的游戏创作游戏。我们的灵感来源于一款需要正确组合配料的烹饪游戏。但与其为不同的组合显示失败信息，我更想探索设计独特食谱的可能性。游戏中提供的线索暗示了完美配方，但玩家可以创造自己的食谱——并获得不同的评价结果。",
        gameplay: "游戏核心是一款解谜游戏，同时也结合了多个小游戏，例如，玩家必须完成特定任务才能获取所需的配料。游戏开始时，玩家需要遵循指示，通过对话学习游戏机制。如果他们选择偏离预设路径，最终会被引导回设计路线，因为没有适当的指导游戏将无法进行。下一步是尽可能多地收集配料：游戏中没有时间限制，因此玩家可以在决定制作炖菜前自由探索地图。一旦玩家决定了要使用的配料，最终场景就会触发。",
        narrative: "我在游戏中使用了幽默的语言来创造轻松有趣的叙事风格。为了漫画书制作最佳炖菜的整个想法本身就很荒谬，因此叙事以及提供给玩家的不同选择都十分诙谐有趣。我还旨在通过玩家与NPC之间的对话提供隐藏线索，以便那些希望追求完美配方的人能获得满意的结果。如果没有适当的背景知识，我们的游戏玩法无法独立存在，我们构建了叙事来将游戏的不同部分结合在一起。",
        challenges: "我很享受制作这款游戏，因为我在叙事和游戏玩法中嵌入了有趣的转折。然而，游戏本身并不如我理想中那么具有挑战性，因为游戏中的小游戏简单直接，容易上手。此外，游戏的可重玩性较低，玩家可能在几轮后就会感到厌倦。这款游戏在某种意义上是可变形的，玩家可以烹饪不同的菜肴来满足各种目的；而且游戏场景/地图可以通过程序生成，避免玩家因重复性过程（如摘苹果）而感到无聊。"
      },
      showcase: {
        title: "游戏展示",
        items: {
          branching: {
            title: "分支叙事",
            description: "叙事系统提供了许多出人意料的转折，黑色幽默的基调与游戏的整体美学相符。你可能会被一个只有牵强附会才能解释得通的奇怪结局所困扰——比如第一个选择，直接导致游戏结束。我们从Sketch设计了叙事框，使其与其他系统UI很好地融合。"
          },
          miniGames: {
            title: "小游戏",
            description: "我们包含了许多小游戏，供玩家收集相应的配料。虽然它们简单直观，但我们希望向游戏的进程中添加一些额外的游戏玩法，并防止玩家快速列出烹饪配料，这并不可取，因为他们会忽略线索，无法达到完美结局（即赢得NPC的青睐）。"
          },
          end: {
            title: "结局",
            description: "根据玩家最终选择的配料，游戏有七种不同的结局；玩家需要向NPC报告并接受他们的评判。由于我们包含了许多非传统炖菜配料选择，如饼干和苹果，许多结局都是为了与这些奇怪的配料相对应。玩家可以随心所欲地创造自己喜欢的炖菜，自由探索不同的结局。"
          },
          inventoryUI: {
            title: "物品栏界面",
            description: "物品栏界面是游戏的重要部分，它引导玩家并决定游戏的结局。玩家在游戏中收集配料后，这些配料会自动显示出来，但玩家可以重新考虑他们的选择，并在继续烹饪前决定最终使用的配料。物品栏允许玩家跟踪他们的收集进度，但它不会提示需要添加什么，这增加了一些挑战性。"
          }
        }
      }
    },
    camDown: {
      title: "禁区实况",
      subtitle: "《禁区实况》是一款多人恐怖游戏，灵感来源于 Content Warning 和 Lethal Company。玩家扮演星际探索者，通过直播他们的冒险旅程来赚取收入。",
      navItems: [
        "背后故事",
        "游戏展示",
        "游戏循环",
        "玩家属性",
        "背景故事",
        "挑战与改进",
        "开发状态"
      ],
      sections: {
        behindTheScene: "我们热爱 Content Warning，因此决定创造属于自己的独特版本。我们在游戏中融入了更多恐怖游戏的经典元素，如无限循环的房间，以加深诡异氛围。在拍摄机制上，我们进行了拓展：玩家不仅仅是简单记录怪物，而是通过接收由AI驱动的直播数据，灵活调整策略，并完成由顶级观众分配的特殊任务。同时，我们认识到多人协作机制在此类游戏中极具吸引力，因此将其作为核心设计之一。",
        showcase: "游戏展示",
        gameplay: "核心游戏循环包含：签约成为\"STELLARCAST\"签约主播、租用飞船与直播设备并组建团队、选择目标地点展开探险、面对外星生物与超自然现象、努力创造精彩直播提升人气、返回基地赚取收入偿还债务，以及购买更高级的设备准备下一次探险。",
        playerAttributes: "游戏通过玩家属性动态系统提供策略深度，包括生命值（决定玩家生存状态）、氧气（决定探索时间）、耐力（控制玩家体力），以及理智值（与怪物接触时下降，低理智会触发负面状态）。",
        background: "在22世纪，StellarCast 垄断了星际传媒领域。玩家作为签约主播，为了赚取\"星眼币（StarEye）\"，必须在宇宙中搜寻外星超自然事件。平台算法会根据恐怖、荒诞与神秘程度评分，决定玩家能否获得更高级的装备。为了探索更危险的星系，玩家必须不断挑战观众对离奇内容的渴望极限。",
        challenges: "学习曲线较陡，需要在恐怖氛围与娱乐性之间找到平衡。需要频繁更新内容以保持玩家的新鲜感与活跃度。",
        development: "开发中 —— 可试玩原型已上线。我们目前正在专注开发程序生成内容与循环房间系统。下一阶段计划优化整体性能，并集成语音聊天与成就系统等外部功能。"
      },
      showcase: {
        title: "游戏展示",
        items: {
          livestream: {
            title: "Livestream的秘密",
            description: "单纯拍摄怪物远远不够——玩家必须制造刺激场面以提升观众参与度：惊险瞬间捕捉险些被攻击的画面，制造紧张氛围；创意混乱鼓励躲避攻击、挑衅怪物、甚至跳舞来吸引更多观众；团队特技则涉及拍摄队友的危险遭遇，创造高能内容。"
          },
          interactive: {
            title: "提升互动体验",
            description: "实时反馈：玩家可以通过直播数据实时调整策略，完成粉丝发布的特定任务。观众参与：死亡的玩家会以幽灵身份继续与团队互动，通过发送消息或提示保持参与感。"
          },
          gameLoop: {
            title: "核心游戏循环",
            description: "1. 签约：成为\"STELLARCAST\"签约主播。2. 装备：租用飞船与直播设备，组建团队。3. 选址：选择目标地点，展开探险。4. 遭遇挑战：面对外星生物与超自然现象。5. 制作内容：努力创造精彩直播，提升人气。6. 回归结算：返回基地，赚取收入，偿还债务。7. 升级装备：购买更高级的设备，准备下一次探险。"
          },
          strategy: {
            title: "策略深度 —— 玩家属性动态系统",
            description: "生命值：决定玩家生存状态的关键指标。氧气：决定探索时间，逐渐消耗，恢复时加速下降。耐力：控制玩家体力，恢复缓慢，需要合理规划使用。理智值：与怪物接触时下降，低理智会触发负面状态，如行动受限、功能受阻，迫使玩家战术性地使用\"CAM DOWN\"技能应对。"
          }
        }
      }
    },
    lamentOfSwan: {
      title: "天鹅挽歌",
      subtitle: "《天鹅挽歌》是一款以故事驱动的2D横版剧情解谜惊悚游戏，融合了心理恐怖元素和强烈戏剧张力。你不是在舞台上起舞，而是在绝望的深渊中挣扎。",
      navItems: [
        "背后故事",
        "游戏展示",
        "背景叙述",
        "开发挑战与改进方向"
      ],
      sections: {
        behindTheScene: "本项目基于我们之前的 Game Jam 作品进行延伸与打磨。玩家将扮演一位痴迷于芭蕾、渴望实现伟大梦想的女舞者，即便她的精神状态正逐渐崩塌。我们精心设计了各类谜题，与叙事紧密结合，利用环境叙事手法突出女主角日益加深的恐惧与抑郁情绪。在制作过程中，我主要负责开发音乐玩法系统——这是贯穿每个章节的核心机制，用以展现女主角的舞蹈与内心世界。此外，我还参与了多个支线谜题及辅助系统（如用户界面 UI）的设计与开发。",
        backgroundStory: "女主角从小就热爱舞蹈，长大后顺利进入了梦想中的舞团。然而，舞团总监对她百般刁难，而她的痛苦与挣扎却无法被其他舞者理解。女主过于追求完美，自视甚高，这样的性格使她逐渐被同伴孤立。在孤独中，她遇到了一位温暖的男舞者，对方的关怀让她重新燃起了希望。然而，信任换来的却是背叛。深受打击的女主变得日渐阴暗、偏执，最终在绝望与愤怒中，一把火烧毁了剧院，所有人葬身火海。",
        challenges: "我们使用 Fungus 工具实现了叙事系统，但在开发过程中遇到了一些功能上的限制。在谜题难度平衡方面也面临挑战——我们希望避免让谜题过于晦涩艰深，同时又要保证它们具有足够的趣味性和挑战性。我们专注于提升环境叙事，力求让叙事与玩法自然融合，为玩家创造一个流畅、沉浸的体验。"
      },
      showcase: {
        title: "游戏展示",
        items: {
          puzzles: {
            title: "互补式支线谜题",
            description: "大量小型谜题构成了游戏的基础框架。玩家需要逐一解开谜题，在探索中逐步揭开女主角内心的秘密，推动故事向前发展。"
          },
          musicGame: {
            title: "音乐玩法系统",
            description: "音乐游戏部分展现了女主角的舞蹈场景。每首曲目都经过精心打磨，各具特色，反映角色在不同情绪阶段的变化。按键模式通过 Wwise 基于音频信号自动生成，打造出动态且与音乐高度同步的游戏体验。"
          },
          artStyle: {
            title: "美术风格",
            description: "整体美术采用手绘风格，融合现代维多利亚美学，呈现出复古的 2D 效果。画面风格接近传统动画或插画故事书，既优雅又略带阴郁气息。"
          },
          storyDriven: {
            title: "叙事体验",
            description: "本作高度强调叙事性，故事线根据玩家的选择发生分支变化。玩家需要仔细阅读叙事面板，从中获取关键线索以推动剧情发展。我们希望通过玩法本身讲述故事，让叙事与机制自然交织，带来沉浸式的游戏体验。"
          }
        }
      }
    },
    designDocs: {
      title: "游戏设计文档",
      subtitle: "游戏设计与规划文档集",
      navItems: [
        "色彩编年史",
        "潘的传人",
        "女巫审判",
        "维塔健身"
      ],
      projectDescriptions: {
        colorChronicles: "一个受中世纪工艺启发的2D策略游戏设计文档。玩家需要从不同材料中提取和混合颜色来制作色素。",
        desofPan: "一个受希腊神话启发的2D冒险游戏设计文档；玩家必须恢复潘神的长笛来拯救他们的土地。游戏具有独特的艺术风格和提高环保意识的主题。",
        witchhunt: "一个受女巫猎杀历史启发的桌游卡牌游戏设计文档；玩家必须互相攻击以避免任意成为受害者。",
        vita: "一款针对年轻女性的健身应用设计文档。它包含了从饮食到锻炼的健康日常各个方面。"
      }
    },
    gismonda: {
      title: "吉斯蒙达",
      subtitle: "一款横版卷轴动作游戏，灵感来源于Victorien Sardou于1894年创作的、以希腊为背景的戏剧《吉斯蒙达》。",
      navItems: [
        "游戏概览",
        "背后故事",
        "展示内容",
        "背景叙述",
        "开发挑战与改进方向"
      ],
      sections: {
        gameOverview: "\"神圣的女神伊厄斯，或者您所偏爱的任何名字，光明之女神……\n我怀着敬意向你祈祷。\"\n《吉斯蒙达》是一款横版卷轴动作游戏，灵感来源于Victorien Sardou于1894年创作的、以希腊为背景的戏剧《吉斯蒙达》。\n故事讲述了一位战士女王寻求复仇与自我成长的旅程。她的性格奠定了我们战斗设计的基础——优雅、沉着而果断。\n游戏机制借鉴了《Hades》的设计理念，玩家可以通过组合不同技能来打造属于自己的战斗风格。我们倾注了大量心血在Boss战的打磨中。Boss拥有两个阶段，每个阶段都经过精心设计，以提供独特而具有挑战性的体验。",
        behindTheScene: "我基于原剧本创作了全新的背景故事和世界观设定，并通过设计与主角性格、情感历程及成长过程紧密相连的技能，将叙事与玩法深度融合。\n玩家的技能体系围绕\"光\"这一元素展开。例如，我设计了\"天光束\"技能：一道强力的阳光光束在短暂延迟后从天而降，轰击玩家当前所在位置，造成高额伤害。为了避免自伤，玩家需要在召唤后迅速走位，这增加了战斗的策略性和风险控制。\n除了世界观与叙事设计，我还参与了核心玩法编程，包括玩家技能、游戏状态管理和3C系统（角色、操作、摄像机），以确保即时战斗过程的流畅性与沉浸感。我还搭建了UI系统，使用多个Canvas进行界面划分，设计并实现了直观且视觉统一的用户界面，兼顾了易用性与叙事风格。",
        backgroundStory: "本作重新诠释了《Gismonda》戏剧发生时期的剧情，以神话风格进行改编。\n在我们的版本中，吉斯蒙达被塑造成一位意志坚定、勇敢果敢的战士女王。\n游戏开场，她获得了守护荣誉与家族的光明女神的祝福。女神赐予她神圣的战斗能力，包括使用\"光之环\"进行攻击与防御的力量。",
        challenges: "我们设计了许多技能与连招系统，但由于开发进度限制，尚未在当前版本中完整实现。未来，我们计划扩展游戏规模，引入更多Boss战，以全面展现游戏的深度与潜力。",
      },
      showcase: {
        title: "展示内容",
        items: {
          abilitySelection: {
            title: "能力选择",
            description: "玩家由女神赋予力量，可从多个选项中进行选择，构建属于自己的战斗技能组合，打造独特的游戏风格。"
          },
          basicAttack: {
            title: "基础攻击",
            description: "我们并未设计防御机制，以鼓励玩家主动迎战Boss。每一次命中的攻击都将为\"光之环\"充能，从而让吉斯蒙达释放特殊技能与能力。"
          },
          ring: {
            title: "光之环机制",
            description: "当光环充能满格时，吉斯蒙达会开始被动回血。使用一次特殊技能将消耗两个戒环，闪避一次将消耗一个戒环。"
          }
        }
      }
    },
    sage: {
      title: "贤者",
      subtitle: "培养学习习惯的应用",
      navItems: [
        "项目概览",
        "特色功能",
        "技术栈"
      ],
      sections: {
        overview: "Sage 是一款理念性的学习应用，旨在促进持续学习而非强制性目标驱动。应用每天在后台提供知识片段，让用户在碎片时间里了解新事物、单词或技能。用户可以设置自己感兴趣的学习偏好，接收个性化内容，同时也可以通过简短文字贡献知识，与社区分享。这里没有教授、作业、考分或承诺，只有为了自我提升而培养的学习习惯。",
        features: "特色功能",
        technology: "技术栈"
      },
      features: {
        personalizedLearning: {
          title: "个性化学习偏好",
          description: "用户可自定义感兴趣的内容类型与主题，从而获得更契合个人需求的学习体验。"
        },
        dailyKnowledge: {
          title: "每日知识碎片",
          description: "每日推送精心策划的知识点，帮助用户养成持续学习的习惯。"
        },
        communityContribution: {
          title: "社区知识共建",
          description: "用户可通过简短文本分享个人见解，丰富社区内容，促进知识共享与交流。"
        },
        personalArchive: {
          title: "个人知识档案",
          description: "支持用户收藏并归档感兴趣的知识内容，方便日后查阅与积累。"
        }
      }
    },
    cautions: {
      title: "专注检测",
      subtitle: "在线课程专注度检测系统",
      navItems: [
        "项目概览",
        "主要功能",
        "技术架构",
        "技术挑战与解决方案"
      ],
      sections: {
        overview: "专注检测是一个容器化应用程序，设计用于监控和分析用户在线课程期间的专注度。该系统由三个相互关联的子系统组成：机器学习客户端收集并分析来自摄像头和鼠标移动等传感器的数据；Web应用程序提供界面以可视化收集的数据并显示分析结果；MongoDB数据库存储传感器数据和分析元数据，实现无缝集成。",
        features: "主要功能",
        architecture: "技术架构",
        challenges: "在开发过程中 我们面临的主要挑战包括：在容器化环境中集成摄像头访问功能，以及在保持低资源消耗的前提下实现实时数据处理。针对摄像头集成问题，我们通过定制的 Docker 配置加以解决，并在必要时采用基于浏览器的摄像头访问作为替代方案。为应对性能限制，我们采用了高效的流式数据处理技术，确保系统具备低延迟和低开销的运行特性。此外，系统还设计了健壮的错误处理机制，即使在传感器数据暂时不可用的情况下，也能保持正常运行。"
      },
      features: {
        cameraDetection: {
          title: "基于摄像头的注意力检测",
          description: "利用人脸识别技术判断用户是否注视屏幕，实现对专注状态的精准评估。"
        },
        mouseTracking: {
          title: "鼠标行为跟踪",
          description: "持续监测鼠标移动、点击与滚动行为，用以分析用户的交互活跃度与参与情况。"
        },
        dataVisualization: {
          title: "实时数据可视化",
          description: "通过响应式网页界面实时展示用户专注度指标与分析结果，提升数据的可读性与交互性。"
        },
        containerized: {
          title: "容器化部署架构",
          description: "采用基于 Docker 的模块化架构，确保系统具备良好的可扩展性、可移植性与便捷的部署能力。"
        }
      }
    }
  }
};

/**
 * Detect browser language and return 'en' or 'zh'
 */
export function detectBrowserLanguage(): Language {
  // Get browser language
  const browserLang = navigator.language.toLowerCase();
  
  // Check if it's Chinese (simplified or traditional)
  if (browserLang.startsWith('zh')) {
    return 'zh';
  }
  
  // Default to English
  return 'en';
}

/**
 * Get translations for the specified language
 */
export function getTranslations(lang: Language): Translations {
  return translations[lang];
}

/**
 * Get translations for the browser's detected language
 */
export function getLocalizedContent(): Translations {
  const lang = detectBrowserLanguage();
  return getTranslations(lang);
} 